export default __webpack_public_path__ + "static/media/cunha.3def8a81.jpg";